import type { TenantSetupGuide } from '@vrplatform/ui-common';
import { create } from 'zustand';

export type Change = {
  id: string;
  title: string | undefined;
  createdAt: string;
  status: 'failed' | 'pending';
};

type State = {
  setupGuide: TenantSetupGuide | null;
  change: Change[];
};

type Actions = {
  setSetupGuide: (updated: TenantSetupGuide | null) => void;
  setJobs: (pending: Change[]) => void;
  reset: () => void;
};

const initialState: State = {
  setupGuide: null,
  change: [],
};

export const useSetupGuideStore = create<State & Actions>()((set, _get) => ({
  ...initialState,
  setJobs: (st) => {
    set((state) => ({
      ...state,
      change: st,
    }));
  },
  setSetupGuide: (updated) => {
    set((state) => ({
      ...state,
      setupGuide: updated,
    }));
  },
  reset: () => {
    set(initialState);
  },
}));
